module.exports = __webpack_public_path__ + "static/media/copy.d57c2c1c.svg";